module.exports = __webpack_public_path__ + "static/scale-model-of-victorville-california-7c6e390caa892df69b27cd94c05069b8.png";